export function initialize() {
    document.addEventListener('change', function(e) {
        let target = e.target;
        let group = target.closest('[data-group="radio-like-checkboxes"]');

        if(group) {
            console.log('111');
            e.preventDefault();

            group.querySelectorAll('[type="checkbox"]').forEach(function(checkbox) {
                if(checkbox !== target) {
                    checkbox.checked = false;
                }
            });
        }
    });
}
